import { create } from 'zustand'

interface GuestState {
  isGuest: boolean
  displayName: string | null
  channelId: string | null
  serverId: string | null
  guestToken: string | null
  // OSPROD-160: the invited channel's name + type, carried from the
  // invite so the guest UI shows the right room and lands in it even
  // when the (scoped) guest serverStore lacks the channel row.
  channelName: string | null
  channelType: string | null
  setGuest: (data: { displayName: string; channelId: string; serverId: string; guestToken: string; channelName?: string; channelType?: string }) => void
  clearGuest: () => void
}

function loadFromStorage(): Partial<GuestState> {
  try {
    const token = localStorage.getItem('guestToken')
    // OSPROD-160: an authenticated user is NEVER a guest. If a JWT is
    // present, ignore any (stale) guestToken so the voice layer uses the
    // real user identity — otherwise the LiveKit token kept identity
    // `guest_*` and everyone saw the logged-in user as "Guest".
    if (!token || localStorage.getItem('token')) return {}
    return {
      isGuest: true,
      guestToken: token,
      displayName: localStorage.getItem('guestName'),
      channelId: localStorage.getItem('guestChannelId'),
      serverId: localStorage.getItem('guestServerId'),
      channelName: localStorage.getItem('guestChannelName'),
      channelType: localStorage.getItem('guestChannelType'),
    }
  } catch {
    return {}
  }
}

export const useGuestStore = create<GuestState>((set) => ({
  isGuest: false,
  displayName: null,
  channelId: null,
  serverId: null,
  guestToken: null,
  channelName: null,
  channelType: null,
  ...loadFromStorage(),

  setGuest: (data) => {
    localStorage.setItem('guestToken', data.guestToken)
    localStorage.setItem('guestName', data.displayName)
    localStorage.setItem('guestChannelId', data.channelId)
    localStorage.setItem('guestServerId', data.serverId)
    if (data.channelName) localStorage.setItem('guestChannelName', data.channelName)
    if (data.channelType) localStorage.setItem('guestChannelType', data.channelType)
    set({
      isGuest: true,
      displayName: data.displayName,
      channelId: data.channelId,
      serverId: data.serverId,
      guestToken: data.guestToken,
      channelName: data.channelName ?? null,
      channelType: data.channelType ?? null,
    })
  },

  clearGuest: () => {
    localStorage.removeItem('guestToken')
    localStorage.removeItem('guestName')
    localStorage.removeItem('guestChannelId')
    localStorage.removeItem('guestServerId')
    localStorage.removeItem('guestChannelName')
    localStorage.removeItem('guestChannelType')
    set({ isGuest: false, displayName: null, channelId: null, serverId: null, guestToken: null, channelName: null, channelType: null })
  },
}))
